import { pipe } from 'ramda';

import { capitalizeAllWords, removeSpaces } from 'utils/common';

import { FormValues } from './DetailsScene/types';

export const getHandledPageName = (formValues: Pick<FormValues, 'name' | 'tags'>) => {
  const formatString = pipe(capitalizeAllWords, removeSpaces);
  return `${formatString(formValues.name)}${formatString(formValues?.tags?.join(' '))}`;
};
